import React from 'react';
import { connect } from 'react-redux';
import * as Bixby from '$/core';
import { AppState } from '$/store';
import Loading from '$/components/loading/Loading';
import { ReactComponent as Clipboard } from '$/assets/icons/Clipboard.svg';
import './ClientDocumentHosting.scss';
import { toastSuccess } from '$/store/toast/actions';

interface IClientDocumentHostingProps {
  client?: Bixby.Models.Client;
  isLoading: boolean;
  profile?: Bixby.Models.Profile;
  dispatchToastSuccess: (message: string) => Promise<void>;
}

const ClientDocumentHosting: React.FC<IClientDocumentHostingProps> = props => {
  const { client, isLoading, dispatchToastSuccess } = props;

  const handleCopyClick = async (clientDataSiteProvider_Id: string) => {
    await navigator.clipboard.writeText(clientDataSiteProvider_Id);
    dispatchToastSuccess('Copied ID to clipboard');
  };

  if (!client) {
    return <></>;
  } else if (isLoading) {
    return <Loading pageLevel />;
  } else {
    return (
      <React.Fragment>
        {isLoading ? (
          <Loading pageLevel />
        ) : (
          <section className="client-document-hosting">
            <h3>Client Document Hosting Access</h3>
            <p>
              These IDs are unique for each client's data site provider, and can be used for adding watermarked files to
              the portal.
            </p>
            {Bixby.Utils.isNullOrEmpty(client.dataSiteProviders) ? (
              <p>No data site providers found for {client.name}</p>
            ) : (
              <div className="grid">
                {client.dataSiteProviders.map(({ dataSiteProvider_Name, id }, ix) => (
                  <React.Fragment key={ix}>
                    <div className="datasiteprovider-name">{dataSiteProvider_Name}</div>
                    <div>
                      <span>{id}</span>
                    </div>
                    <button type="button" title="Copy to Clipboard" onClick={() => handleCopyClick(id)}>
                      <Clipboard />
                    </button>
                  </React.Fragment>
                ))}
              </div>
            )}
          </section>
        )}
      </React.Fragment>
    );
  }
};

const mapDispatchToProps = (dispatch: any) => ({
  dispatchToastSuccess: (message: string) => dispatch(toastSuccess(message)),
});

const mapStateToProps = (state: AppState) => {
  return {
    client: state.clientState.currentClient,
    isLoading: state.clientState.isLoading,
    profile: state.profileState.profile,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientDocumentHosting);
